<script lang="ts">
  import { fly } from 'svelte/transition';
  import { toasts, dismissToast } from '../lib/stores/toast';

  // Floating top-right stack of toasts subscribed to the toast store.
  // Mounted once inside PageShell — multiple PageShells per nav cycle
  // would double-mount, but our route layout guarantees one shell.
  // role=status / aria-live=polite so screen readers announce without
  // interrupting the user's current focus.
</script>

<div class="toast-host" role="region" aria-label="Notifications">
  {#each $toasts as toast (toast.id)}
    <div
      class="toast-host__toast toast-host__toast--{toast.variant}"
      role="status"
      aria-live="polite"
      transition:fly={{ x: 20, duration: 200 }}
    >
      <span class="toast-host__message">{toast.message}</span>
      <button
        type="button"
        class="toast-host__close"
        aria-label="Dismiss notification"
        onclick={() => dismissToast(toast.id)}
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <line x1="6" y1="6" x2="18" y2="18" />
          <line x1="6" y1="18" x2="18" y2="6" />
        </svg>
      </button>
    </div>
  {/each}
</div>
